import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	selected: {
		id: 'software-context-menu.menu-renderer.context-menu-inner.context-menu-node.bulk-indicator.selected',
		description: 'Shown to indicate the number of selected cards on a contextual menu',
		defaultMessage: 'Selected',
	},
});
